import {useGetGroup, useGetGroupActivities} from '@/modules/user-groups/api'
import {EventLog, Group} from '@cypro/engine/schema'
import {createContext, PropsWithChildren, useContext} from 'react'

interface State {
  group: Group
  activities?: EventLog[]
}

interface Props extends PropsWithChildren {
  group: Group
}

const UserGroupContext = createContext<State>({} as State)

export function UserGroupProvider({children, group: initialGroup}: Props) {
  const [group] = useGetGroup(initialGroup.id)
  const [activities] = useGetGroupActivities(initialGroup.id)

  return (
    <UserGroupContext.Provider value={{group: group || initialGroup, activities}}>{children}</UserGroupContext.Provider>
  )
}

export function useUserGroupContext() {
  return useContext(UserGroupContext)
}
